var isNative = require('../lang/isNative');

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = object == null ? undefined : object[key];
  return isNative(value) ? value : undefined;
}

module.exports = getNative;



/*****************
 ** WEBPACK FOOTER
 ** /usr/src/sentry/~/react-bootstrap/~/lodash-compat/internal/getNative.js
 ** module id = 790
 ** module chunks = 0
 **/